import styled, { css } from 'styled-components';

export const ImgBox = styled.img`
    width: 100%;
    height: 100%;
`;

type Props = {
    $isHidden: boolean;
    $left: number;
    $top: number;
}

export const Wrap = styled.div<Props>`
    position: absolute;
    width: 40px;
    height: 40px;
    opacity: 1;

    transform: translate(-50%, -50%);

    transition: opacity .15s linear;

    left: ${({ $left }) => $left}%;
    top: ${({ $top }) => $top}%;

    ${({ $isHidden }) => $isHidden && css`
        opacity: 0;
    `}
`;
